<template>
  <div class="workload">
    <div style="padding-bottom: 20px">
      <el-radio-group v-model="conditions" @change="tabConditions">
        <el-radio-button label="1">按天</el-radio-button>
        <el-radio-button label="2">按月</el-radio-button>
        <el-radio-button label="3">按年</el-radio-button>
      </el-radio-group>
    </div>
    <div style="margin-bottom: 20px">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
        <el-form-item label="日期区间" label-width="70px" v-show="conditions === '1'">
          <el-date-picker
              @input="search"
              v-model="searchForm.dayTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              style="width: 220px"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="月份区间" label-width="70px" v-show="conditions === '2'">
          <el-date-picker
              @input="search"
              v-model="searchForm.monthTime"
              type="monthrange"
              value-format="yyyy-MM-dd"
              style="width: 220px"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="年份区间" label-width="70px" v-show="conditions === '3'">
          <el-date-picker
              @input="search"
              v-model="searchForm.startYear"
              type="year"
              value-format="yyyy"
              style="width: 220px"
              placeholder="开始年份"
              unlink-panels>
          </el-date-picker>
          -
          <el-date-picker
              @input="search"
              v-model="searchForm.endYear"
              type="year"
              style="width: 220px"
              value-format="yyyy"
              unlink-panels
              placeholder="结束年份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="代理商" label-width="60px">
          <el-select v-model="searchForm.operator" @change="operatorClick" placeholder="请选择">
            <el-option
                v-for="item in operatorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="药房" label-width="60px">
          <el-select v-model="searchForm.pharmacy" @change="tabConditions" filterable placeholder="请选择">
            <el-option
                v-for="item in pharmacyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="date"
            :label="timeName">
          <template slot-scope="scope">
            <span v-if="conditions==='1'">{{scope.row.date}}</span>
            <span v-if="conditions==='2'">{{scope.row.year}}-{{scope.row.month}}</span>
            <span v-if="conditions==='3'">{{scope.row.year}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="deviceCode"
            label="设备名称">
        </el-table-column>
        <el-table-column
            prop="deviceCode"
            label="设备编码">
        </el-table-column>
        <el-table-column
            prop="deviceTypeCode"
            label="型号"
            align="center">
        </el-table-column>
        <el-table-column
            prop="dosage"
            align="center"
            label="剂量">
        </el-table-column>
        <el-table-column
            prop="prescriptionAmount"
            align="center"
            label="处方数">
        </el-table-column>
        <el-table-column
            prop="prescriptionDaysAmount"
            align="center"
            label="处方天数">
        </el-table-column>
        <el-table-column
            prop="cupAmount"
            align="center"
            label="杯数">
        </el-table-column>
      </el-table>
    </div>
    <!--    &lt;!&ndash; 分页 &ndash;&gt;-->
    <!--    <div style="margin-top: 20px">-->
    <!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
    <!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import {getDay} from "@/service/common";
export default {
  name: "workload",
  data() {
    return {
      conditions: "1",
      pickerType:'date',
      searchForm:{
        dayTime: [],
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      tableData:[],
      operatorOptions:[],
      pharmacyOptions:[],
      timeName:'日期'
    }
  },
  components: {
    //someComponent
    Pagination
  },
  methods: {
    //
    tabConditions(){
      let url = ''
      let data = {}
      switch (this.conditions) {
        case "1":
          url = '/Statistics/PharmacyStatistics/GetDayDeviceWorkLoad'
          data = {
            startDate: this.searchForm.dayTime[0]?this.searchForm.dayTime[0]:getDay(-1,'-'),
            endDate: this.searchForm.dayTime[1]?this.searchForm.dayTime[1]:getDay(-0,'-'),
            pharmacyId: this.searchForm.pharmacy,
          }
          this.timeName='日期'
          break;
        case "2":
          url = '/Statistics/PharmacyStatistics/GetMonthDeviceWorkLoad'
          data = {
            startDate: this.searchForm.monthTime[0],
            endDate: this.searchForm.monthTime[1],
            pharmacyId: this.searchForm.pharmacy,
          }
          this.timeName='月份'
          break;
        default:
          data = {
            startYear: this.searchForm.startYear,
            endYear: this.searchForm.endYear,
            pharmacyId: this.searchForm.pharmacy,
          }
          this.timeName='年份'
          url = '/Statistics/PharmacyStatistics/GetYearDeviceWorkLoad'
      }
      this.init(url, data)
    },
    search(){
      this.tabConditions()
    },
    init(url, data) {
      this.axios
          .get(url, {params: data})
          .then((res) => {
            this.tableData = res.list
            this.tableData.forEach(item=>{
              if(item.date){
                item.date=this.dayjs(item.date).format('YYYY/MM/DD HH:mm')
              }
            })
          })
    },
    operatorList(){
      this.axios
          .get('/api/Dic?dicType=6')
          .then((res) => {
            this.operatorOptions=res
            this.operatorOptions.forEach(item=>{
              item.label=item.name
              item.value=item.id
            })
          })
    },
    operatorClick(e){
      let data={
        operatorId:e,
        page:'1',
        pageSize:'2000'
      }
      this.axios
          .get('/api/Pharmacy/GetByOperator',{params:data}).then((res) => {
        this.pharmacyOptions=res.list
        this.pharmacyOptions.forEach(item=>{
          item.label=item.name
          item.value=item.id
        })
      })
    },
    // ----------分页控制-------------
    clear(){
      this.searchForm={
        name:'',
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
  },
  mounted() {
    //
    this.operatorList()
    this.tabConditions()
  }
}
</script>

<style lang="scss" scoped>
.workload {

}
</style>